import { DetailsRowView } from './DetailsRow.view';

export const DetailsRow = DetailsRowView;
